import { lazy } from "react";

// ** Document title
const TemplateTitle = "%s - Vuexy React Admin Template";

// ** Default Route
const DefaultRoute = "/order/list";
const CustomerDefaultRoute = "/customer-order/list";

// ** Merge Routes
const Routes = [
  // {
  //   path: "/home",
  //   component: lazy(() => import("../../views/Home")),
  // },
  {
    path: "/dashboard/analytics",
    component: lazy(() => import("../../views/dashboard/analytics")),
  },
  {
    path: "/dashboard/order",
    component: lazy(() => import("../../views/dashboard/order")),
  },
  {
    path: "/dashboard/driver",
    component: lazy(() => import("../../views/dashboard/driver")),
  },
  {
    path: "/dashboard/member",
    component: lazy(() => import("../../views/dashboard/member")),
  },
  {
    path: "/dashboard/driver-dashboard",
    component: lazy(() => import("../../views/dashboard/driver_dashboard")),
  },
  {
    path: "/dashboard/attendance-dashboard",
    component: lazy(() => import("../../views/dashboard/attendance_dashboard"))
  },
  {
    path: "/dashboard/monitor-order-dashboard",
    component: lazy(() => import("../../views/dashboard/monitor_order_dashboard"))
  },
  {
    path: "/dashboard/contract",
    component: lazy(() => import("../../views/dashboard/contract"))
  },
  {
    path: "/second-page",
    component: lazy(() => import("../../views/SecondPage")),
  },
  {
    path: "/realtime",
    component: lazy(() => import("../../views/realtime")),
  },
  {
    path: "/login",
    component: lazy(() => import("../../views/Login")),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/tracking/:trackingNumber?",
    component: lazy(() => import("../../views/tracking")),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/resetPassword/:randomID",
    component: lazy(() => import("../../views/resetPassword")),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/driver/list",
    component: lazy(() => import("../../views/driver/list")),
  },
  {
    path: "/driver/vehicle/view/:id",
    component: lazy(() => import("../../views/driver/vehicle-view")),
  },
  {
    path: "/driver/vehicle",
    component: lazy(() => import("../../views/driver/vehicle")),
  },
  {
    path: "/driver/import",
    component: lazy(() => import("../../views/driver/import")),
  },
  {
    path: "/driver/plan-list",
    component: lazy(() => import("../../views/driver/plan-list")),
  },
  {
    path: "/driver/incident-report-list",
    component: lazy(() => import("../../views/driver/incident-report-list")),
  },
  {
    path: "/driver/incident-report/view/:id",
    component: lazy(() => import("../../views/driver/incident-report-view")),
  },
  {
    path: "/driver/incident-report/print/:id",
    component: lazy(() => import("../../views/driver/incident-report-print")),
  },
  {
    path: "/manager/list",
    component: lazy(() => import("../../views/manager/list")),
  },
  {
    path: "/manager/add",
    component: lazy(() => import("../../views/manager/add")),
  },
  {
    path: "/order/list",
    component: lazy(() => import("../../views/order/list")),
  },
  {
    path: "/order/reassign-history",
    component: lazy(() => import("../../views/order/reassign-history-list")),
  },
  {
    path: "/customer-order/list",
    component: lazy(() => import("../../views/order/list")),
  },
  {
    path: "/customer-order/view/:id",
    component: lazy(() => import("../../views/order/view")),
  },
  {
    path: "/order/location",
    component: lazy(() => import("../../views/order/location")),
  },
  {
    path: "/order/import",
    component: lazy(() => import("../../views/order/import")),
  },
  {
    path: "/order/process-address",
    component: lazy(() => import("../../views/order/processAddress")),
  },
  {
    path: "/order/new",
    component: lazy(() => import("../../views/order/new")),
  },
  {
    path: "/order/hschan-cbf",
    component: lazy(() => import("../../views/order/hschan-cbf")),
  },
  {
    path: "/order/hschan-route",
    component: lazy(() => import("../../views/order/hschan-route")),
  },
  {
    path: "/order/add",
    component: lazy(() => import("../../views/order/add")),
  },
  {
    path: "/order/view/:id",
    component: lazy(() => import("../../views/order/view")),
  },
  {
    path: "/order/print/:id",
    component: lazy(() => import("../../views/order/print")),
  },
  {
    path: "/order/print-half/:id",
    component: lazy(() => import("../../views/order/print-half")),
  },
  {
    path: "/order/customer-record",
    component: lazy(() => import("../../views/order/customer-record")),
  },
  {
    path: "/order/customer-record-detail/:id",
    component: lazy(() => import("../../views/order/customer-record-detail")),
  },
  {
    path: "/error",
    component: lazy(() => import("../../views/Error")),
    layout: "BlankLayout",
  },
  {
    path: "/member/list",
    component: lazy(() => import("../../views/member/list")),
  },
  {
    path: "/member/business",
    component: lazy(() => import("../../views/member/business")),
  },
  {
    path: "/member/view/:id",
    component: lazy(() => import("../../views/member/view")),
  },
  {
    path: "/driver/view/:id",
    component: lazy(() => import("../../views/driver/view")),
  },
  {
    path: "/driver/add",
    component: lazy(() => import("../../views/driver/add")),
  },
  {
    path: "/other/driver-withdraw",
    component: lazy(() => import("../../views/other/driver-withdraw")),
  },
  {
    path: "/report/download-report",
    component: lazy(() => import("../../views/report/download-report")),
  },
  {
    path: "/admin/inbox-message-view/:id",
    component: lazy(() => import("../../views/admin/inbox-message-view")),
  },
  {
    path: "/admin/inbox-message-add",
    component: lazy(() => import("../../views/admin/inbox-message-add")),
  },
  {
    path: "/admin/inbox-message-view/:id",
    component: lazy(() => import("../../views/admin/inbox-message-view")),
  },
  {
    path: "/admin/list",
    component: lazy(() => import("../../views/admin/list")),
  },
  {
    path: "/admin/project-code",
    component: lazy(() => import("../../views/admin/project-code")),
  },
  {
    path: "/admin/inbox-message-list",
    component: lazy(() => import("../../views/admin/inbox-message-list")),
  },
  {
    path: "/admin/no-avatar-dirver-list",
    component: lazy(() => import("../../views/admin/no-avatar-dirver-list")),
  },
  {
    path: "/project/list",
    component: lazy(() => import("../../views/project/list")),
  },
  {
    path: "/project/rate-card",
    component: lazy(() => import("../../views/project/rate-card")),
  },
  {
    path: "/project/edit/:id",
    component: lazy(() => import("../../views/project/edit")),
  },
  {
    path: "/routes/list",
    component: lazy(() => import("../../views/routes/list")),
  },
  {
    path: "/routes/list-district-weekdays",
    component: lazy(() => import("../../views/routes/list-district-weekdays")),
  },
  {
    path: "/routes/district-weekdays/edit/:id",
    component: lazy(() => import("../../views/routes/edit-district-weekdays")),
  },
  {
    path: "/routes/district-weekdays/view/:id",
    component: lazy(() => import("../../views/routes/edit-district-weekdays")),
  },
  {
    path: "/routes/district-weekdays/create/",
    component: lazy(() => import("../../views/routes/edit-district-weekdays")),
  },
  {
    path: "/routes/edit/:id",
    component: lazy(() => import("../../views/routes/edit")),
  },
  {
    path: "/routes/view/:id",
    component: lazy(() => import("../../views/routes/edit")),
  },
  {
    path: "/routes/create/",
    component: lazy(() => import("../../views/routes/edit")),
  },
  {
    path: "/routes/address-list/",
    component: lazy(() => import("../../views/routes/address-list")),
  },
  {
    path: "/routes/address-edit/:id",
    component: lazy(() => import("../../views/routes/address-edit")),
  },
  {
    path: "/attendance/record",
    component: lazy(() => import("../../views/attendance/attendance-record")),
  },
  {
    path: "/attendance/schedule",
    component: lazy(() => import("../../views/attendance/attendance-schedule"))
  },
  {
    path: "/attendance/import",
    component: lazy(() => import("../../views/attendance/attendance-schedule-import"))
  },
  {
    path: "/attendance/group/view/:id",
    component: lazy(() => import("../../views/attendance/attendance-group-view"))
  },
  {
    path: "/attendance/group",
    component: lazy(() => import("../../views/attendance/attendance-group"))
  },
  {
    path: "/attendance/report",
    component: lazy(() => import("../../views/attendance/attendance-report"))
  },
  {
    path: "/attendance/supplement/view/:id",
    component: lazy(() => import("../../views/attendance/attendance-supplement-view"))
  },
  {
    path: "/attendance/supplement",
    component: lazy(() => import("../../views/attendance/attendance-supplement"))
  },
  {
    path: "/attendance/leave/view/:id",
    component: lazy(() => import("../../views/attendance/leave-view"))
  },
  {
    path: "/attendance/leave",
    component: lazy(() => import("../../views/attendance/leave"))
  },
  {
    path: "/driver/location",
    component: lazy(() => import("../../views/driver/location"))
  },
  {
    path: "/driver/chat",
    component: lazy(() => import("../../views/driver/chat"))
  },
  {
    path: "/driver/ticket",
    component: lazy(() => import("../../views/driver/traffic-ticket-list"))
  },
  {
    path: "/driver/view-ticket/:id",
    component: lazy(() => import("../../views/driver/view-ticket"))
  },
  {
    path: "/driver/permission-management/view/:id",
    component: lazy(() => import("../../views/driver/permission-management-view"))
  },
  {
    path: "/driver/permission-management",
    component: lazy(() => import("../../views/driver/permission-management"))
  },
  {
    path: "/announcement/announcement-list",
    component: lazy(() => import("../../views/announcement/list"))
  },
  {
    path: "/announcement/handbook",
    component: lazy(() => import("../../views/announcement/handbook"))
  },
  {
    path: "/redPocket/redeem",
    component: lazy(() => import("../../views/redPocket/redeem"))
  },
  {
    path: "/announcement/termCondition",
    component: lazy(() => import("../../views/announcement/termCondition"))
  },
  {
    path: "/vote/list",
    component: lazy(() => import("../../views/vote/list"))
  },
  {
    path: "/vote/create",
    component: lazy(() => import("../../views/vote/create"))
  },
  {
    path: "/vote/view/:id",
    component: lazy(() => import("../../views/vote/view"))
  },
  {
    path: "/staff/department",
    component: lazy(() => import("../../views/staff/department"))
  },
  {
    path: "/staff/position",
    component: lazy(() => import("../../views/staff/position"))
  },
  {
    path: "/staff/list",
    component: lazy(() => import("../../views/staff/list"))
  },
  {
    path: "/staff/opinion-list",
    component: lazy(() => import("../../views/staff/opinion-list"))
  },
  {
    path: "/staff/opinion-view/:id",
    component: lazy(() => import("../../views/staff/opinion-view"))
  },
  {
    path: "/survey/ref",
    component: lazy(() => import("../../views/survey/ref")),
    layout: "BlankLayout",
  },
  {
    path: "/survey/create",
    component: lazy(() => import("../../views/survey/create")),
  },
  {
    path: "/survey/list",
    component: lazy(() => import("../../views/survey/list")),
  },
  {
    path: "/survey/exe/:id/:token?",
    component: lazy(() => import("../../views/survey/exe")),
    layout: "BlankLayout",
  },
  {
    path: "/survey/edit/:id",
    component: lazy(() => import("../../views/survey/edit")),
  },
  {
    path: "/contract/list-contract",
    component: lazy(() => import("../../views/contract/list-contract"))
  },
  {
    path: "/contract/detail-contract/:id",
    component: lazy(() => import("../../views/contract/detail-contract"))
  },
  {
    path: "/contract/monthly-summary-contract/:id/:month",
    component: lazy(() => import("../../views/contract/monthly-summary-contract"))
  },
];

export { DefaultRoute, TemplateTitle, Routes, CustomerDefaultRoute };
